import {
  Chip,
  getKeyValue,
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
} from "@nextui-org/react";
import { formatToVND } from "../../helper";
import { ShopOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import path from "../../ultils/path";
import { useAccountStore } from "../../store";

const CardItemRevenueStore = ({
  data,
  idx,
  isShowBtn = true,
  isShowTotal = true,
}: {
  data?: any;
  idx?: any;
  isShowBtn?: boolean;
  isShowTotal?: boolean;
}) => {
  const navigate = useNavigate();
  const { info } = useAccountStore();

  if (!data || !data.userGroup) {
    return <div className="text-center text-gray-500">No data available</div>;
  }

  return (
    <div className="flex justify-center cursor-pointer w-full flex-col max-sm:pl-[14px]">
      <Table
        onClick={() => {
          if (info?.role === "ROLE_ADMIN")
            navigate(path.REVENUE_MACHINE, {
              state: { storeCode: data?.userGroup, dataRevenue: data },
            });
          else {
            navigate(path.REVENUE_MACHINE_USER, {
              state: { storeCode: data?.userGroup, dataRevenue: data },
            });
          }
        }}
        className="md:block hidden "
        aria-label="Example table with client side pagination"
        classNames={{
          wrapper: "min-h-[10vh]",
        }}
      >
        <TableHeader>
          <TableColumn
            className="lg:text-[16px] text-base"
            width={200}
            key="userGroup"
          >
            <div className={"flex items-center gap-1"}>
              <span
                className={`text-xl ${
                  idx >= 0
                    ? idx === 0
                      ? "text-green-400"
                      : idx === 1
                      ? "text-yellow-400"
                      : idx === 2
                      ? "text-red-500"
                      : "text-gray-700"
                    : "hidden"
                }`}
              >
                #{+idx + 1}
              </span>
              <span>User Group</span>
            </div>
          </TableColumn>
          <TableColumn
            className="lg:text-[16px] text-base"
            width={200}
            key="groupName"
          >
            Group Name
          </TableColumn>
          <TableColumn
            className="lg:text-[16px] text-base"
            width={200}
            key="revenueTotal"
          >
            Revenue Total
          </TableColumn>
          <TableColumn
            className="lg:text-[16px] text-base"
            width={200}
            key="quantity"
          >
            Quantity
          </TableColumn>
          <TableColumn
            className="lg:text-[16px] text-base"
            width={200}
            key="totalCoupon"
          >
            Total Coupon
          </TableColumn>
          <TableColumn
            className="lg:text-[16px] text-base"
            width={200}
            key="couponPrice"
          >
            Coupon Price
          </TableColumn>
          {/* <TableColumn
            className="lg:text-[16px] text-base"
            width={200}
            key="f1Counter"
          >
            F1 Counter
          </TableColumn> */}<TableColumn
            className="lg:text-[16px] text-base"
            width={200}
            key="epayCount"
          >
            Epay Counter
          </TableColumn><TableColumn
            className="lg:text-[16px] text-base"
            width={200}
            key="epayMoney"
          >
            Epay Money
          </TableColumn>
          <TableColumn
            className="lg:text-[16px] text-base"
            width={200}
            key="totalF1"
          >
            F1 Price
          </TableColumn>
        </TableHeader>
        <TableBody items={[data]}>
          {(i: any) => (
            <TableRow key={i.userGroup}>
              {(columnKey) => {
                if (columnKey === "userGroup") {
                  return (
                    <TableCell className="lg:text-[0.9rem] text-[0.8rem] ml-28">
                      <span className="text-photo-time-pink-light font-semibold">
                        {getKeyValue(i, columnKey)}
                      </span>
                    </TableCell>
                  );
                } else if (columnKey === "groupName") {
                  return (
                    <TableCell className="lg:text-[0.9rem] text-[0.8rem]">
                      <span className="text-gray-600 font-medium">
                        {getKeyValue(i, columnKey)}
                      </span>
                    </TableCell>
                  );
                } else if (columnKey === "quantity") {
                  return (
                    <TableCell className="lg:text-[0.9rem] text-[0.8rem]">
                      <Chip color="warning" variant="flat">
                        {getKeyValue(i, columnKey)}
                      </Chip>
                    </TableCell>
                  );
                } else if (columnKey === "totalCoupon") {
                  return (
                    <TableCell className="lg:text-[0.9rem] text-[0.8rem]">
                      <span className="font-bold">
                        {getKeyValue(i, columnKey)}
                      </span>
                    </TableCell>
                  );
                } 
                // else if (columnKey === "f1Counter") {
                //   return (
                //     <TableCell className="lg:text-[0.9rem] text-[0.8rem]">
                //       <Chip color="success" variant="flat">
                //         {getKeyValue(i, columnKey)}
                //       </Chip>
                //     </TableCell>
                //   );
                // } 
                 else if (columnKey === "epayCount") {
                  return (
                    <TableCell className="lg:text-[0.9rem] text-[0.8rem]">
                      <Chip color="success" variant="flat">
                        {getKeyValue(i, columnKey)}
                      </Chip>
                    </TableCell>
                  );
                }
                else if (columnKey === "epayMoney") {
                  return (
                    <TableCell className="lg:text-[0.9rem] text-gray-600 font-bold text-[0.8rem]">
                       <span>{formatToVND(getKeyValue(i, columnKey))} VNĐ</span>
                    </TableCell>
                  );
                }
                else {
                  return (
                    <TableCell className="lg:text-[0.9rem] text-gray-600 font-bold text-[0.8rem]">
                      <span>{formatToVND(getKeyValue(i, columnKey))} VNĐ</span>
                    </TableCell>
                  );
                }
              }}
            </TableRow>
          )}
        </TableBody>
      </Table>
      <div
        onClick={() => {
          if (info?.role === "ROLE_ADMIN")
            navigate(path.REVENUE_MACHINE, {
              state: { storeCode: data?.userGroup, dataRevenue: data },
            });
          else {
            navigate(path.REVENUE_MACHINE_USER, {
              state: { storeCode: data?.userGroup, dataRevenue: data },
            });
          }
        }}
        className="w-[96%] md:hidden min-h-[22vh] flex justify-between bg-photo-time-pink-light bg-opacity-15 rounded-lg p-2"
      >
        <div className="w-[40%] flex items-center">
          <div className="flex flex-col h-[84%] justify-center p-1 w-[100%] bg-white items-center rounded-lg">
            <span className="text-2xl text-photo-time-pink-light">
              <ShopOutlined />
            </span>
            <span className=" text-photo-time-pink-main text-sm">
              {data?.userGroup}
            </span>
            <span className="font-medium text-center text-sm text-gray-500">
              {data?.groupName}
            </span>
          </div>
        </div>
        <div className="w-full px-5 sm:mt-2 mt-5">
          <table className="w-[100%]">
            <thead>
              <tr className="">
                <th className="w-[30%] text-center"></th>
                <th className="w-[30%] sm:pb-3 pb-2 text-sm text-photo-time-pink-light text-center">
                  Amount
                </th>
                <th className="w-[30%] sm:pb-3 pb-2 text-sm text-photo-time-pink-light text-center">
                  Money
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className=" bg-red-400 bg-opacity-10">
                <td className="text-sm sm:py-3 py-2 w-[33%] text-photo-time-pink-light text-center">
                  Revenue
                </td>
                <td className="text-sm sm:py-3 py-2 w-[33%] text-gray-600 text-center">
                  {data?.quantity}
                </td>
                <td className="text-sm sm:py-3 py-2 w-[33%] text-gray-600 text-center">
                  {data?.revenueTotal && formatToVND(data?.revenueTotal)}
                </td>
              </tr>
              <tr>
                <td className="text-sm sm:py-3 py-2 w-[33%] text-photo-time-pink-light text-center">
                  Coupon
                </td>
                <td className="text-sm sm:py-3 py-2 w-[33%] text-gray-600 text-center">
                  {data?.totalCoupon}
                </td>
                <td className="text-sm sm:py-3 py-2 w-[33%] text-gray-600 text-center">
                 { formatToVND(data.couponPrice)}
                </td>
              </tr>
              <tr className="bg-gray-400 bg-opacity-10">
                <td className="text-sm sm:py-3 py-2 w-[33%] text-photo-time-pink-light text-center">
                  F1
                </td>
                <td className="text-sm sm:py-3 py-2 w-[33%] text-gray-600 text-center">
                  {data?.totalF1}
                </td>
                <td className="text-sm sm:py-3 py-2 w-[33%] text-gray-600 text-center">
                  {formatToVND(data?.totalF1)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="flex justify-end lg:items-end items-center w-full my-2 xl:gap-4 gap-2 max-sm:w-[96%]">
        {isShowBtn && (
          <button
            onClick={() => {
              navigate(path.REVENUE_MACHINE_OVERALL, {
                state: { storeCode: data?.userGroup },
              });
            }}
            className="rounded-full xl:px-[20px] lg:px-[14px] px-[12px] py-[1px] h-fit bg-photo-time-pink-main hover:bg-opacity-90 cursor-pointer"
          >
            <span className="text-white text-sm">Overall</span>
          </button>
        )}

        {isShowTotal && (
          <div className="flex flex-col">
            <span className="lg:text-base text-sm">Total Income:</span>
            <span className="lg:text-xl text-base max-sm:text-base font-semibold text-photo-time-pink-main">
              {data?.revenueTotal != null &&
            
               formatToVND(+data.revenueTotal - +data.couponPrice)}
              VNĐ
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default CardItemRevenueStore;
